import React from "react";
import Topbar from "../../../components/DashboardComponents/Topbar/Topbar";
import EventPipeline from "../../../components/DashboardComponents/EventPipeline/EventPipeline";
import InstitutionProfile from "../../../components/DashboardComponents/InstitutionProfile/InstitutionProfile";
import UpcomingSessions from "../../../components/DashboardComponents/UpcomingSessions/UpcomingSessions";
import LinkedMembers from "../../../components/DashboardComponents/LinkedMembers/LinkedMembers";
import StatCards from "../../../components/DashboardComponents/StatCards/StatCards";
import styles from "../Dashboard.module.css";

const Dashboard = () => {
  return (
    <>
      <Topbar heading={"Institution Members Dashboard"} role="institution" />
      <div className={styles.stats}>
        <StatCards />
      </div>
    </>
  );
};

export default Dashboard;
